/* eslint-disable no-empty */
export const loadPersistedPropertyDetailsState = () => {
  try {
    const serializedState = sessionStorage.getItem("propertyDetails");
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const savePersistedPropertyDetailsState = state => {
  try { 
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem("propertyDetails", serializedState);
  } catch (err) {}
};
